import { useEffect, useState } from 'react';
import { siteConfig } from '../config/site';
import {
  getAnalyticsConsent,
  initializeGoogleAnalytics,
  setAnalyticsConsent,
  type AnalyticsConsent,
} from '../lib/analytics';

export function CookieConsent() {
  const enabled = Boolean(siteConfig.analytics.googleAnalyticsId);
  const [consent, setConsent] = useState<AnalyticsConsent>(() =>
    enabled ? getAnalyticsConsent() : 'declined',
  );

  useEffect(() => {
    if (consent === 'accepted') initializeGoogleAnalytics();
  }, [consent]);

  if (!enabled || consent !== null) return null;

  const choose = (value: Exclude<AnalyticsConsent, null>) => {
    setAnalyticsConsent(value);
    setConsent(value);
  };

  return (
    <aside className="cookie-banner" aria-label="Analytics preferences">
      <div>
        <strong>Optional analytics</strong>
        <p>We use anonymous analytics only after you accept. Store, account and licensing functions work without them.</p>
      </div>
      <div className="cookie-banner__actions">
        <button className="button button--ghost" type="button" onClick={() => choose('declined')}>Decline</button>
        <button className="button button--dark" type="button" onClick={() => choose('accepted')}>Accept</button>
      </div>
    </aside>
  );
}
